<mat-progress-bar [color]="color" mode="indeterminate" />
